import type { RefObject } from "react";

export default function focusOnCompletedDomUpdate<T extends HTMLElement>(
  ref: RefObject<T> | null,
) {
  if (ref) {
    setTimeout(() => {
      ref.current?.focus();
    }, 0);
  }
}
